<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="100%"
        width="100%"
        viewBox="0 0 512 512"
        fill="currentColor"
    >
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc. -->
        <path
            d="M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3L285.6 506.3c-13.9 5-29.1 5-43.1 0L42.5 437.7C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3L234.5 5.7zM256 34.2L64 102.8v274.4l192 68.6 192-68.6V102.8L256 34.2z"
        />
    </svg>
</template>
